import styles from "./Join_NothingYet.module.scss";

import { useTranslation } from "react-i18next";

import { PageContainer } from "@/modules/shared/components/PageContainer";

export function Join_NothingYet() {
  const { t } = useTranslation();

  return (
    <PageContainer variant="constrained">
      <div className={styles.container}>
        <span className={styles.title}>
          {t("coachingSession.nothingYet.title")}
        </span>
        <span className={styles.description}>
          {t("coachingSession.nothingYet.description")}
        </span>
      </div>
    </PageContainer>
  );
}
